module.exports = __webpack_public_path__ + "static/media/naef.da198ff0.png";